import RoutesMap from 'route_control/RouteControl'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'
import showAccessDeniedAlert from './accessDenied'
import { toggleBool } from '../redux/slices/globalSlice'
import SessionManager from './sessionManager'

const approveRejectHandler = async ({
    title,
    text,
    cancelbt,
    confirmbt,
    itemId,
    action,
    successTitle,
    successText,
    successConfirmbt,
    wrong_toast,
    navigate,
    dispatch,
    message = false,
}) => {
    const result = await Swal.fire({
        title,
        text,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#8c9269',
        cancelButtonColor: '#EF3D50',
        cancelButtonText: cancelbt,
        confirmButtonText: confirmbt,
        allowOutsideClick: false,
        allowEscapeKey: false,
    })

    if (result.isConfirmed) {
        try {
            const response = await action({ id: itemId })

            if (response?.payload?.status === 200) {
                dispatch(toggleBool())
                Swal.fire({
                    title: successTitle,
                    text: message ? response?.payload?.data?.message : successText,
                    icon: 'success',
                    confirmButtonText: successConfirmbt,
                })
            } else if (response?.payload?.status === 401) {
                SessionManager.removeCookie('user_token')
                navigate(RoutesMap.LOGIN.path)
            } else if (response?.payload?.status === 400) {
                toast.error(response?.payload?.data?.message, { position: 'bottom-right', closeOnClick: true })
            } else if (response?.payload?.status === 403) {
                showAccessDeniedAlert(navigate)
            } else {
                toast.error(wrong_toast, { position: 'bottom-right', closeOnClick: true })
            }
        } catch (error) {
            toast.error(wrong_toast, { position: 'bottom-right', closeOnClick: true })
        }
    }
}

export default approveRejectHandler;